<h2 class="title-modal">WIDGET FILTER</h2>

<div>
    <ddv-dashboard-filters
        [clientCode]="clientCode ?? ''"
        [inMultiEnvironment]="isMultiClient"
        [funds]="funds"
        [clients]="clients"
        [fuzzyDates]="ccFuzzyDates"
        [namedQueries]="namedQuery ? [namedQuery] : []"
        [queryParams]="widgetFilters"
        (applyFunds)="onApplySelectedFunds($event)"
        (applyClients)="onApplySelectedClients($event)"
        (applyDateFilter)="onApplyDateChanges($event)"
    >
        <ddv-additional-filters-dropdown
            [widgetId]="widgetId ?? 0"
            [filters]="nonUdfFilters"
            (filtersApplied)="onDbFiltersApplied($event)"
        >
        </ddv-additional-filters-dropdown>
        <ddv-refresh-restore
            [showRestore]="true"
            (refresh)="onRefreshCurrentWidget()"
            (restore)="onRestoreCurrentWidget()"
        >
        </ddv-refresh-restore>
    </ddv-dashboard-filters>
</div>
